module.exports = __webpack_public_path__ + "static/media/reshot-icon-sun-energy-WL9MVB4TYD.ff170f23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reshot-icon-sun-energy-WL9MVB4TYD.svg
// module id = 242
// module chunks = 0